/*
 * Section admin CYCLIQ FIT : programme, prix de référence interne et seuils
 * d'orientation commerciale. Ces valeurs sont administrables sans toucher
 * au code. Rappels : le score FIT n'est jamais affiché aux prospects et les
 * tarifs ne sont JAMAIS affichés dans le parcours (annoncés uniquement
 * pendant l'appel).
 */

import { BadgeEuro } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const sectionClass = "mt-6 rounded-2xl bg-white border border-[rgba(35,82,119,0.14)] p-5 sm:p-6 shadow-[var(--shadow-sm)]";
const inputClass = "mt-1 rounded-xl border-[rgba(35,82,119,0.25)]";

const Field = ({ id, label, value, onChange, hint, type = "text", testId }) => (
  <div>
    <Label htmlFor={id} className="text-xs font-semibold text-[#333333]">{label}</Label>
    <Input
      id={id}
      type={type}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      data-testid={testId}
      className={inputClass}
    />
    {hint ? <p className="mt-1 text-[11px] text-[#9E9E9E]">{hint}</p> : null}
  </div>
);

export const FitConfigSection = ({ fit, onPatch }) => (
  <section className={sectionClass} data-testid="admin-fit-section">
    <div className="flex items-center gap-2">
      <BadgeEuro className="w-4 h-4 text-[#235277]" aria-hidden="true" />
      <h2 className="font-heading text-base font-semibold text-[#060606]">CYCLIQ FIT : offre et qualification</h2>
    </div>
    <p className="mt-1 text-xs leading-relaxed text-[#9E9E9E]">
      Questionnaire commercial séparé du diagnostic (4 questions, sans question budget).
      Les tarifs ci dessous sont une référence interne : ils ne sont jamais affichés aux
      prospectes et sont annoncés uniquement pendant l'appel. Le score FIT reste interne
      et n'est jamais montré.
    </p>
    <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
      <Field id="fit-program-name" label="Nom du programme" value={fit.programName}
        onChange={(v) => onPatch("programName", v)} testId="admin-fit-program-name" />
      <Field id="fit-program-duration" label="Durée" value={fit.programDuration}
        onChange={(v) => onPatch("programDuration", v)} testId="admin-fit-program-duration" />
      <Field id="fit-price-full" label="Paiement comptant (référence interne)" value={fit.priceFull}
        onChange={(v) => onPatch("priceFull", v)} testId="admin-fit-price-full" />
      <Field id="fit-price-installments" label="Paiement fractionné (référence interne)" value={fit.priceInstallments}
        onChange={(v) => onPatch("priceInstallments", v)} testId="admin-fit-price-installments" />
      <Field id="fit-price-installments-total" label="Total du paiement fractionné" value={fit.priceInstallmentsTotal}
        onChange={(v) => onPatch("priceInstallmentsTotal", v)}
        hint="Référence interne : jamais affichée aux prospectes, jamais présentée comme équivalente au comptant."
        testId="admin-fit-price-installments-total" />
    </div>
    <div className="mt-4 grid grid-cols-2 gap-4">
      <Field id="fit-threshold-high" label="Seuil prioritaire (niveau A)" type="number" value={fit.thresholdHigh}
        onChange={(v) => onPatch("thresholdHigh", v)}
        hint="Score sur 100 à partir duquel le calendrier est proposé directement."
        testId="admin-fit-threshold-high" />
      <Field id="fit-threshold-qualified" label="Seuil qualifié (niveau B)" type="number" value={fit.thresholdQualified}
        onChange={(v) => onPatch("thresholdQualified", v)}
        hint="Sous ce score : orientation vers les conseils, sans réservation poussée."
        testId="admin-fit-threshold-qualified" />
    </div>
  </section>
);
